// Module
var code = "<div><div id=\"sticky-tab-container\"><div class=\"inner-tab-container\"><ul class=\"nav nav-{{tabset.type || 'tabs'}}\" ng-class=\"{'nav-stacked': vertical, 'nav-justified': justified}\" ng-transclude></ul></div></div><div class=\"tab-content\"><div class=\"tab-pane\" ng-repeat=\"tab in tabset.tabs\" ng-class=\"{active: tabset.active === tab.index}\" uib-tab-content-transclude=\"tab\"></div></div></div>";
// Exports
var _module_exports =code;;
var path = 'app/components/tabs/sticky-tabs.tpl.html';
var angular = require('angular');
angular.module('pims').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
export default path;